import { useEffect, useState, useCallback } from "react";
import styles from "./Retired.module.css";
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
import Title from "../../components/title";
import NewsBar from "../../components/product/NewsBar";
import { getRetiredNewsPaginationList } from "../../services/news/news.service";

const NewsList = () => {
  let [loading, setLoading] = useState(false);
  let [news, setNews] = useState([]);
  let [page, setPage] = useState(0);
  let [breadCrumbItems, setBreadCrumbItems] = useState([]);
  let [hasNextPage, setHasNextPage] = useState(false);
  let [nextPageLoading, setNextPageLoading] = useState(false);
  let [nextPageLink, setNextPageLink] = useState(false);
  const isMobile = useState(window.mobileCheck());
  const getNextPage = (pageLink) => {
    setNextPageLoading(true);
    setPage(pageLink);
  };

  const fetchData = useCallback(() => {
    setLoading(true);
    getRetiredNewsPaginationList(encodeURIComponent(page)).then(({ data }) => {
      setNextPageLoading(false);
      setLoading(false);
      if (data && data.data && data.data.data) {
        setNews((n) => [...n].concat([...data.data.data]));
        setNextPageLink(data.data.__next);
      }

      if (data && data.data && data.data.data.length % 16 === 0) {
        setHasNextPage(true);
      } else {
        setHasNextPage(false);
      }
    });
  }, [page]);
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  useEffect(() => {
    setBreadCrumbItems([
      { title: "خانه", url: "/" },
      { title: "اخبار", url: "/news/list" },
    ]);
  }, []);
  return (
    <>
      <Title title={"لیست اخبار"} />
      <div className={"container"}>
        <div className={"row"}>
          <div className={"col-xs-12"}>
            <div className="row">
              <BreadCrumb items={breadCrumbItems} />
            </div>
          </div>
          <div id={styles.newsListBox} className={"clearfix"}>
            <div className={"col-xs-12 col-md-12"}>
              <div
                id={styles.newsListWrapper}
                className={styles.newsListContainer}
              >
                <div className={styles.newsListTitle}>
                  آرشیو اخبار بازنشستگان
                </div>
                <div className={!isMobile[0] ? styles.newsListPanel : ""}>
                  {news && news.length > 0 ? (
                    <div className="row">
                      {news.map((item, key) => (
                        <div className="col-xs-12 col-md-12 pull-right">
                          <NewsBar key={key + "-product-bar"} news={item} />
                        </div>
                      ))}
                    </div>
                  ) : loading ? (
                    <div className="loading-wrapper">
                      <img
                        src={"../../../assets/image/loading.svg"}
                        alt={"در حال بار گذاری"}
                      />
                    </div>
                  ) : (
                    <div className={"no-product"}>خبری یافت نشد</div>
                  )}
                </div>
                {hasNextPage && news.length > 0 ? (
                  <button
                    id={styles.nextPageButton}
                    className={nextPageLoading ? "disabled-loader" : null}
                    onClick={
                      !nextPageLoading ? () => getNextPage(nextPageLink) : null
                    }
                  >
                    {nextPageLoading ? (
                      "..."
                    ) : (
                      <i className={"fa fa-arrow-down"}></i>
                    )}
                  </button>
                ) : null}
              </div>
            </div>
            <div className={"clearfix"}></div>
          </div>
          <div className={"clearfix"}></div>
        </div>
      </div>
    </>
  );
};

export default NewsList;
